import icons from "../styles/icons/icons";
import { CargoList, CargoShow } from "../views/cargoes";
import { DriverEdit, DriverList, DriverShow } from "../views/drivers";
import { FleetList } from "../views/fleets/fleets/fleet-list";
import { StationCreate, StationEdit, StationList, StationShow } from "../views/fleets/stations";
import { MSTruckCreate, MSTruckEdit, MSTruckList, MSTruckShow } from "../views/fleets/ms-trucks";
import { Scheduling } from "../views/scheduling";
import { WaybillList, WaybillShow } from "../views/waybills";
import OnlineBillsList from "../views/online-bills/online_bills_page";
import { MSDriverCreate, MSDriverEdit, MSDriverList, MSDriverShow } from "../views/fleets/ms-drivers";
import { FleetCreate } from "../views/fleets/fleets/fleet-create";
import { FleetShow } from "../views/fleets/fleets/fleet-show";
import { FleetEdit } from "../views/fleets/fleets/fleet-edit";
import { PushHistoryList, PushHistoryShow } from "../views/push-history";
import { ReserveCapacityCreate, ReserveCapacityEdit, ReserveCapacityList, ReserveCapacityShow } from "../views/reserve-capacity";
import { DriverScheduleList } from "../views/scheduling-calendar/driver-schedule-list";
import { DriverScheduleShow } from "../views/scheduling-calendar/driver-schedule-show";
import { DriverScheduleCreate } from "../views/scheduling-calendar/driver-schedule-create";
import { DriverScheduleEdit } from "../views/scheduling-calendar/driver-schedule-edit";
import ScheduleCalendar from "../views/scheduling-calendar/schedule-calendar";
import { GroupList } from "../views/groups/group-list";
import { GroupShow } from "../views/groups/group-show";
import { GroupEdit } from "../views/groups/group-edit";
import { GroupCreate } from "../views/groups/group-create";
import { OrganizationList } from "../views/organizations/organization-list";
import { OrganizationShow } from "../views/organizations/organization-show";
import { OrganizationEdit } from "../views/organizations/organization-edit";
import ManualReview from "../views/manual-review/manual-review";
import VerifyUsersList from "../views/verify_users/verify_users";
import VerifyTrucksList from "../views/verify_trucks/verify_trucks";
import ReferncePriceList from "../views/cargos/reference_prices";
import UserList from "../views/users/users";
import MapDrivers from "../views/map/map_drivers";
import AllDriverListMap from "../views/map/all_driver_list_map";
import { ThirdPartyClientList } from "../views/authorization/third-party-clients";
import { ThirdDataRequestList } from "../views/authorization/third-data-requests";
import AgentRecordsPage from "../views/agent/agent_records_page";

export const resources = [
  {
    name: "drivers",
    icon: icons.drivers,
    options: { label: "App司机" },
    list: DriverList,
    show: DriverShow,
    edit: DriverEdit,
  },
  {
    name: "waybills",
    icon: icons.orders,
    options: { label: "App运单" },
    list: WaybillList,
    show: WaybillShow,
  },
  {
    name: "billings",
    icon: icons.shoppingCart,
    options: { label: "结算账单" },
    list: OnlineBillsList,
  },
  {
    name: "validCargos",
    icon: icons.cargos,
    options: { label: "App货物" },
    list: CargoList,
    show: CargoShow,
  },
  {
    name: "schedulings",
    icon: icons.scheduling,
    options: { label: "调度" },
    list: Scheduling,
    show: DriverShow,
  },
  {
    name: "fleets",
    icon: icons.route,
    options: { label: "车队" },
    list: FleetList,
    create: FleetCreate,
    show: FleetShow,
    edit: FleetEdit,
  },
  {
    name: "stations",
    icon: icons.station,
    options: { label: "车队站点" },
    list: StationList,
    create: StationCreate,
    show: StationShow,
    edit: StationEdit,
  },
  {
    name: "msDrivers",
    icon: icons.msDrivers,
    options: { label: "多渠道司机" },
    list: MSDriverList,
    create: MSDriverCreate,
    show: MSDriverShow,
    edit: MSDriverEdit,
  },
  {
    name: "msTrucks",
    icon: icons.msTrucks,
    options: { label: "多渠道货车" },
    list: MSTruckList,
    create: MSTruckCreate,
    show: MSTruckShow,
    edit: MSTruckEdit,
  },
  {
    name: "push",
    options: { label: "推送记录" },
    list: PushHistoryList,
    show: PushHistoryShow,
  },
  {
    name: "reserveCapacity",
    options: { label: "储备运力" },
    list: ReserveCapacityList,
    show: ReserveCapacityShow,
    edit: ReserveCapacityEdit,
    create: ReserveCapacityCreate

  },
  {
    name: "driverSchedules",
    icon: icons.scheduling,
    options: { label: "调度追踪" },
    list: DriverScheduleList,
    show: DriverScheduleShow,
    create: DriverScheduleCreate,
    edit: DriverScheduleEdit
  },
  {
    name: "calendar",
    icon: icons.scheduling,
    options: { label: "调度日历" },
    list: ScheduleCalendar,
  },
  {
    name: "groups",
    icon: icons.groups,
    options: { label: "部门管理" },
    list: GroupList,
    show: GroupShow,
    edit: GroupEdit,
    create: GroupCreate
  },
  {
    name: "organizations",
    icon: icons.groups,
    options: { label: "企业管理" },
    list: OrganizationList,
    show: OrganizationShow,
    edit: OrganizationEdit,
  },
  {
    name: "manualReview",
    icon: icons.review,
    options: { label: "人工审核" },
    list: ManualReview,
  },
  {
    name: "verify/user",
    icon: icons.review,
    options: { label: "实名认证列表" },
    list: VerifyUsersList,
  },
  {
    name: "verify/truck",
    icon: icons.review,
    options: { label: "车辆认证列表" },
    list: VerifyTrucksList,
  },
  {
    name: "cargos/price",
    icon: icons.cargos,
    options: { label: "参考价管理" },
    list: ReferncePriceList,
  },
  {
    name: "users",
    icon: icons.groups,
    options: { label: "用户管理" },
    list: UserList,
  },
  {
    name: "map/map_drivers",
    icon: icons.drivers,
    options: { label: "地图司机" },
    list: MapDrivers,
  },
  {
    name: "map/all_drivers_map",
    icon: icons.drivers,
    options: { label: "司机地图" },
    list: AllDriverListMap,
  },
  {
    name: "thirdPartyClients",
    icon: icons.settingsIcon,
    options: { label: "第三方客户端管理" },
    list: ThirdPartyClientList,
  },
  {
    name: "thirdDataRequests",
    icon: icons.settingsIcon,
    options: { label: "预授权管理" },
    list: ThirdDataRequestList,
  },
  {
    name: "communication",
    icon: icons.communication,
    options: { label: "沟通记录" },
  },
  {
    name: "agentDispatchRecords",
    icon: icons.agent,
    options: { label: "智能体操作记录" },
    list: AgentRecordsPage,
  },
];
